/**
 * Direct booking is still an unreleased feature — every apartment currently lacks a booking
 * site, so the "no direct booking" warnings (calendar banner, timeline warning dot) would show
 * for everyone and just be noise. Flip this to true once direct booking actually ships; both
 * warnings reappear immediately with no other code changes needed.
 */
export const DIRECT_BOOKING_RELEASED = false;
